<aside>
  <div class="content-display">
    <div class="row hiring-info">
      <div class="col-lg-12 hiring-info-column">
        <div class="procurement-title title-color">
          <strong>Procurement & Hiring Information:</strong>
        </div>
      </div>
      <!-- <div class="col-lg-4 hiring-info-img-column">
        <img
          src="assets/img/icons/hiring-information.svg"
          alt="..."
          width="66"
          height="81"
          class="d-none d-md-block"
        />
      </div> -->
    </div>
    <div class="row hiring-info">
      <div class="col-lg-1"></div>
      <div class="col-lg-5 padding-top-15 vendors shade-vendor">
        <div class="padding-top-15 residents"><strong class="title-color">For vendors:</strong></div>
        <div>
          <!-- <strong class="print-vendors title-color">For vendors:</strong> -->
          <span
            ><a
              href="https://www.nyc.gov/site/nycha/business/procurement-opportunities.page"
              target="_blank"
              class="text-dark"
              >Find out</a
            >
            about procurement opportunities at this and other developments.</span
          >
        </div>
      </div>
      <!-- <div class="padding-top-15 separate-content"><hr /></div>
      <div class="padding-top-15 residents"><strong>For residents:</strong></div> -->

      <div class="col-lg-5 padding-top-15 contact shade-contact">
        <div class="padding-top-15 residents"><strong class="title-color">For residents:</strong></div>
        <div>
          <!-- <strong class="print-residents title-color">For residents:</strong> -->
          <span
            ><a href="http://opportunitynycha.org/" target="_blank" class="text-dark">
              Contact the Office of Resident Empowerment & Sustainability
            </a>
            to find out about Section 3 job opportunities.</span
          >
        </div>
      </div>
      <div class="col-lg-1"></div>
    </div>
  </div>
</aside>
